import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },

        themes: {

            light: {
                primary: '#005C33',
                secondary: '#FF5E00',
                accent: '#212121',
                error: '#b71c1c',
                background: '#FFD2BD',
                gray: '#dbdbdb'
            },
        },
    },
});
